import { WidgetCheckoutOptimizationConfigSchema } from "@redotech/redo-model/checkouts/widget";
import { z } from "zod";

export const getCheckoutOptimizationConfig = {
  input: z.object({}),
  output: WidgetCheckoutOptimizationConfigSchema,
};
